import * as React from 'react';
import SVGInline from 'react-svg-inline';

import { LogosLocale } from './logos.locale';

import styles from './Logos.scss';

import pchLogo from './pch-logo.svg';
import ispLogo from './isp-logo.svg';
import microsoftLogo from './microsoft-logo.svg';
import heurekaLogo from './heureka-logo.svg';
import cdn77Logo from './cdn77-logo.svg';
import shLogo from './sh-logo.svg';

interface LogosProps {
  locale: LogosLocale;
}

export interface LogoItem {
  src: string;
  height: number;
}

const logosArray: LogoItem[] = [
  {
    src: ispLogo,
    height: 60,
  },
  {
    src: microsoftLogo,
    height: 35,
  },
  {
    src: heurekaLogo,
    height: 40,
  },
  {
    src: cdn77Logo,
    height: 50,
  },
  {
    src: shLogo,
    height: 30,
  },
];

const Logos: React.SFC<LogosProps> = ({ locale }) => (
  <div className="container">
    <div className="row">
      <div className={styles.logosContainer}>
        {logosArray.map(item => (
          <SVGInline
            svg={item.src}
            key={item.src}
            height={`${item.height}px`}
            className={styles.logo}
            component="div"
          />
        ))}
      </div>
    </div>
    <div className="row">
      <div className={styles.footer}>
        <SVGInline svg={pchLogo} height="30px" className={styles.footerImage} component="div" />
        <span>{locale.description}</span>
      </div>
    </div>
  </div>
);

export default Logos;



// WEBPACK FOOTER //
// /www/client/src/components/HomePage/Logos/Logos.tsx